/* global process */
import { put, takeEvery, all } from 'redux-saga/effects'

import Api from '../Api'

import * as gameActions from '../Game/game.actions'
import * as actions from './auth.actions'

/**
 *  Initiate the login process
 *  @param   {string}     licenseId  The license id
 *  @param   {string}     token      The LMS auth token
 */
export function* startLogin(token) {
  yield put(actions.startLogin(token))
}

/**
 *  Login the user the game using the token provided
 *  @param  {object}  action  Redux action
 */
export function* login(action) {
  const token = action.data.token

  try {
    const gameToken = yield Api.post('/games-core/login', { headers: { 'X-AUTH-TOKEN': token } })

    if (!gameToken) throw new Error('Unauthorized - No token found.')

    window.SessionStorage.setItem('gameToken', gameToken.token)
    yield put(actions.finishLoginSuccess(gameToken))
  } catch (e) {
    yield put(actions.finishLoginError(e))
  }
}
/**
 *  Initiate the init player clone process
 *  @param   {string}     licenseId  The license id
 *  @param   {string}     token      The LMS auth token
 */
export function* startClone(token) {
  yield put(actions.startClone(token))
}

/**
 *  init player clone game using the token provided
 *  @param  {object}  action  Redux action
 */
export function* initClone(action) {
  const token = action.data.token
  window.SessionStorage.setItem('gameToken', token)

  yield fetchUserInfo()
}
/**
 *  Logout the user the game using and destroy the token
 *  @param  {object}  action  Redux action
 */
export function* logout() {
  try {
    yield put(gameActions.returnToPlatform())
  } catch (e) {
    console.log(e)
  }
}
/**
 *  Get user and license info to initialize the game
 *  @param   {object}     action  Redux action
 */
export function* fetchUserInfo() {
  try {
    const userInfo = yield Api.get('/games-core/player', {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: 0,
      },
    })
    yield put(actions.finishGetUserInfoSuccess(userInfo))

    try {
      window.SessionStorage.setItem('licenseId', userInfo.licenseData.id)
    } catch (e) {
      // No empty block ;-)
    }
  } catch (e) {
    yield put(actions.finishGetUserInfoError(e))
  }
}

/**
 *  Initiate all auth process required before the game initialization
 */
export function* initAuth() {
  const [, tutorial] = window.location.pathname.split('/')
  if (tutorial !== 'tutorial') {
    try {
      const urlSearchParams = new URLSearchParams(location.search)
      const token = urlSearchParams.get('token') || _loadSessionToken()
      // clone token
      const cloneToken = urlSearchParams.get('t')
      if (cloneToken) {
        console.info('🔴🔴🔴🔴 CLONE MODE 🔴🔴🔴🔴')
        window.SessionStorage.clear()
        yield startClone(cloneToken)
      } else {
        if (!token) {
          throw new Error('No token info found on query')
        }
        window.SessionStorage.clear()
        yield startLogin(token)
        if (process.env.CLEAN_URL_TOKEN) {
          window.history.replaceState({}, document.title, window.location.pathname)
        }
      }
    } catch (e) {
      const gameToken = window.SessionStorage.getItem('gameToken')
      if (!gameToken) {
        yield logout()
      } else {
        yield put(actions.finishLoginSuccess(gameToken))
      }
    }
  }
}

/**
 *  Log the errors
 */
export function logError(action) {
  const e = action.data

  if (process.env.DEBUG_MODE) {
    console.error(e.name, e)
  }
}

function _loadSessionToken() {
  const cookie = document.cookie.split(';').find((item) => item.trim().startsWith('GLSID'))
  if (cookie) {
    const token = cookie.split('=')[1]
    return token
  }
  return null
}

function _getTokenData(token) {
  if (!token) return {}
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )
    // eslint-disable-next-line
    return JSON.parse(jsonPayload);
  } catch (error) {
    return {}
  }
}

/**
 *  Auth sagas
 */
export function* sagas() {
  yield all([
    takeEvery(actions.LOGIN_START, login),
    takeEvery(actions.START_CLONE, initClone),
    takeEvery(actions.LOGOUT, logout),
    takeEvery(actions.LOGIN_FINISH_SUCCESS, fetchUserInfo),
    takeEvery(actions.LOGIN_FINISH_ERROR, logError),
    initAuth(),
  ])
}
